import React from 'react'
import { node, object } from 'prop-types'
import { useTheme } from 'emotion-theming'

export const AdsenseContext = React.createContext()

/**
 * @function AdsenseProvider
 * @param {boolean} adsense :: determines if ads are on
 * @param {boolean} adsenseMobile :: determines if mobile ads are on
 * @param {node} children :: children nodes
 */
export function AdsenseProvider({ adsense, adsenseMobile, children }) {
	const { MATCH_MEDIA } = useTheme()
	const adsenseMediaQuery = adsenseMobile ? MATCH_MEDIA.XS : MATCH_MEDIA.M

	return (
		<AdsenseContext.Provider
			value={{
				adsenseMediaQuery,
				hasAdsense: adsense,
				hasAdsenseMobile: adsenseMobile,
			}}
		>
			{children}
		</AdsenseContext.Provider>
	)
}
AdsenseProvider.propTypes = {
	children: node,
	siteConstants: object,
}
